import React from "react"
import { FaMapMarkerAlt, FaEnvelope, FaInstagram } from "react-icons/fa"
//Components
import LocateIcons from "./locate-icons"
//Styled Components
import { LocateWrapper } from "./../../styles/homeStyles"

export default function Locate({ locateText }) {
  return (
    <LocateWrapper>
      <div className="section-contact-inner">
        <div className="wrapper-text">
          <h2>
            {locateText.h2}{" "}
            <span role="img" aria-label="location">
              📍
            </span>
          </h2>
        </div>
      </div>
      <div className="legend">{locateText.legend}</div>
      <div className="locate-me-wrapper">
        <LocateIcons
          dataLocate="cpiocova@gmail.com"
          locateText={locateText}
          Icon={FaEnvelope}
        />
        <LocateIcons
          dataLocate="instagram.com/cpioweb"
          locateText={locateText}
          Icon={FaInstagram}
        />
        <LocateIcons
          dataLocate="Caracas, Venezuela"
          locateText={locateText}
          Icon={FaMapMarkerAlt}
        />
      </div>
    </LocateWrapper>
  )
}
